import React, { useEffect } from "react"
import { connect } from "react-redux"
import { generateBizminerRatios } from "../../../../store/modules/financialRatios/actions";
import YearBar from "../BizminerRatios/YearBar";
import Item from "../BizminerRatios/Item";

function FirstResearchRatios({
  dispatchGenerateBizminerRatios,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateBizminerRatios()
  }, [])

  // Methods
  const handleGenerateBizminerRatios = async () => {
    await dispatchGenerateBizminerRatios()
  }

  return (
    <div>

      <YearBar />

      <Item label = "Current Ratio" tooltip = "Current Assets / Current Liabilities" />
      <Item label = "Quick Ratio" tooltip = "( Cash + Marketable Securities + Accounts Receivable ) / Current Liabilities" />
      <Item label = "Days Receivables" tooltip = "( Accounts Receivable / Business Revenue ) × 365" />
      <Item label = "Days Inventory" tooltip = "( Inventory / Cost of Sales ) × 365" />
      <Item label = "Inventory Turnover" tooltip = "Business Revenue / Inventory" />
      <Item label = "Payables Turnover" tooltip = "Business Revenue / Accounts Payable" />
      <Item label = "Days Payable" tooltip = "( Accounts Payable / Cost of Sales ) × 365" />
      <Item label = "Working Capital Turnover" tooltip = "Business Revenue / ( Current Assets - Current Liabilities )" />
      
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateBizminerRatios() {
    await dispatch(generateBizminerRatios())
  },
})

export default connect(null, mapDispatchToProps)(FirstResearchRatios)
